exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mw-900[data-v-b34e0f0c] {\n  min-width: 400px;\n}\n.divider[data-v-b34e0f0c] {\n  border-right: 1px solid #393535;\n  margin-right: 15px;\n}\n", ""]);

// exports
